// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3X2Dw","content":"styles_content__2dZcn","checkbox":"styles_checkbox__3cJHD","checkboxLabel":"styles_checkboxLabel__2JjVK"};